var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"favourites"},_vm._l((_vm.favourites),function(favourite,index){return _c('favourite-item',{key:`fav-${index}`,attrs:{"mediaLibraryID":favourite,"imageSelector":_vm.imageSelector}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }